import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { loadEmailNotifications, saveEmailNotifications } from '../../lib/settings'
import Loader from '../../components/Loader'
import '../onboarding/onboarding.css'
import './settings.css'

const FIELDS = [
  { key: 'new_messages', label: 'New messages' },
  { key: 'new_likes', label: 'New likes' },
  { key: 'new_matches', label: 'New matches' },
  { key: 'reminders', label: 'Reminders' }
]

const SettingsEmailNotifications = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const [prefs, setPrefs] = useState(null)
  const [saving, setSaving] = useState(false)
  const [dirty, setDirty] = useState(false)
  const [saveError, setSaveError] = useState('')

  useEffect(() => {
    if (!user) return
    loadEmailNotifications(user.id).then(setPrefs)
  }, [user])

  const toggle = (key) => {
    setSaveError('')
    setPrefs((p) => (p ? { ...p, [key]: !p[key] } : p))
    setDirty(true)
  }

  const onSave = async () => {
    if (!user || !prefs || !dirty) return
    setSaving(true)
    setSaveError('')
    const { error } = await saveEmailNotifications(user.id, prefs)
    setSaving(false)
    if (error) {
      setSaveError(error)
      return
    }
    setDirty(false)
    const fresh = await loadEmailNotifications(user.id)
    setPrefs(fresh)
  }

  const onBack = () => navigate('/app/profile/settings')

  if (prefs === null) {
    return (
      <div className="onboarding-page">
        <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 80 }}>
          <div style={{ marginBottom: 24 }}>
            <button type="button" className="link" onClick={onBack}>← Back</button>
          </div>
          <h1 className="h1">Email notifications</h1>
          <Loader text="Loading…" />
        </div>
      </div>
    )
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 80 }}>
        <div style={{ marginBottom: 24 }}>
          <button type="button" className="link" onClick={onBack}>← Back</button>
        </div>
        <h1 className="h1">Email notifications</h1>
        {FIELDS.map(({ key, label }) => (
          <div key={key} className="settings-row">
            <div style={{ fontSize: 15 }}>{label}</div>
            <button
              type="button"
              role="switch"
              aria-checked={!!prefs[key]}
              className={`settings-toggle ${prefs[key] ? 'on' : ''}`}
              onClick={() => toggle(key)}
            >
              <span className="settings-toggle-knob" />
            </button>
          </div>
        ))}
        {saveError && <p className="p" style={{ color: '#c00', marginTop: 12 }}>{saveError}</p>}
        {dirty && (
          <button
            type="button"
            className="settings-modal-btn settings-modal-btn-primary"
            style={{ marginTop: 24, width: '100%' }}
            onClick={onSave}
            disabled={saving}
          >
            {saving ? <Loader text="Saving…" inline /> : 'Save'}
          </button>
        )}
      </div>
    </div>
  )
}

export default SettingsEmailNotifications
